module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB0AAAASCAYAAACnxdXaAAAAAXNSR0IArs4c6QAAARFJREFUSEu91UlKBTEQBuAq+zxVOcG7igMiHsDh4Sw4IT71uRFxOotX6KR7rRcxvxREkUZ7lSTLLOojReovpownhDCPMX445+ZjZTmX2bbtpGmaNwAMYFNVb/6rnQ01wHu/zsz3RGR1t0Vk9hecFU3wGjM/JHgqIldDODtqQAhhlYgeDQawo6qXv+EiaHrxCjM/EVFDRLsicvENF0MN6LpuCcBLgvdF5Mzui6IJXgTwajCAQ1U94RACco3NWB0An8xsrT6ujgI4qt3eA1U9LYr2fb8cY3xOH2lPRM6LfiTvvY2MgQtVRqZ6OHjvf2Iwxjh1zpWNwUHgb4nIddHAH6y2DVW9rbLabIkT0buI3I0FxRe4dYz/1SXnNAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/right.png
// module id = JfLI
// module chunks = 1